import React from "react";
import { render } from "react-dom";
import { Provider } from "react-redux";
import { Route, Switch, BrowserRouter } from "react-router-dom";
import AppContainer from "./react/containers/AppContainer";
import Search from "./react/containers/Search";
import store from "./react/redux/store";
import "./index.css";
import Header from "./react/components/common/header";
import Footer from "./react/components/common/footer";

render(
  <Provider store={store}>
    <BrowserRouter>
      <Header/>
      <AppContainer>
      <Switch>
          <Route exact path="" component={Search}/>          
      </Switch>
      </AppContainer>
      <Footer/>

    </BrowserRouter>
  </Provider>,
  document.getElementById("root"));

